module.exports = __webpack_public_path__ + "static/a-titan-raises-the-bar-hero-1920x1080-c3c385a6aacbd9f6d2dbd489b265d043.jpg";